import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLibrary: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"library, stuff, vinyl-records"} maskId="square-filled-radius-0-stroke-1-IconLibrary"><path fillRule="evenodd" clipRule="evenodd" d="M12.7395 2.83447L21.1653 20.7393L20.2605 21.1651L11.8347 3.26027L12.7395 2.83447ZM4 2.99978V20.9998H3V2.99978H4ZM9 2.99978V20.9998H8V2.99978H9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLibrary;
